<div class="flex flex-col md:flex-row flex-auto gap-8 p-4 h-[85vh] lg:h-[65vh]">

<!-- Left Column: Product Detail / Editor (Scrollable) -->
    <div class="flex-auto rounded-lg border overflow-y-auto">
        <!-- Placeholder View when no product is selected -->
        <div *ngIf="!selectedProduct" class="flex flex-col items-center justify-center h-full text-secondary p-8">
            <mat-icon svgIcon="heroicons_outline:cube" class="!w-16 !h-16"></mat-icon>
            <p class="mt-4 text-lg text-center">Select an item from the list to edit</p>
            <p class="text-center" *ngIf="!reviewMode">Or, add a new item to get started.</p>
        </div>

        <!-- Editor View when a product is selected -->
        <div *ngIf="selectedProduct" class="p-6 md:p-8">
            <div class="flex flex-col xl:flex-row gap-8">
                <!-- Left side of editor: Fields & Description -->
                <div class="flex-auto">
                    <div class="flex flex-col sm:flex-row sm:items-start gap-4 mb-6">
                        <mat-form-field class="flex-auto" floatLabel="always">
                            <mat-label>Name</mat-label>
                            <input
                                matInput
                                placeholder="Enter a name for the item"
                                maxlength="250"
                                [readonly]="reviewMode"
                                [(ngModel)]="selectedProduct.ds_name"
                                (keyup)="onKeyupAutosave()">
                        </mat-form-field>
                        <mat-form-field class="w-full sm:w-28 shrink-0" floatLabel="always">
                            <mat-label>Order</mat-label>
                            <input
                                [readonly]="reviewMode"
                                (keyup)="onKeyupAutosave()"
                                placeholder="e.g. 1"
                                type="number"
                                matInput
                                [(ngModel)]="selectedProduct.vi_order">
                        </mat-form-field>
                    </div>

                    <div>
                        <mat-label>Description</mat-label>
                        <quill-editor
                            class="mt-2 w-full"
                            [readOnly]="reviewMode"
                            (onEditorCreated)="onEditorCreated($event)"
                            (onContentChanged)="onKeyupAutosave()"
                            [(ngModel)]="selectedProduct.tx_description"
                            [bounds]="'self'"
                            [modules]="quillModules"
                            [formats]="quillFormats"
                            appEditableQuillHtml
                            appEditableQuillHtmlButtonText="Source">
                        </quill-editor>
                    </div>
                </div>

                <!-- Right side of editor: Image -->
                <div class="w-full xl:w-80 flex-shrink-0">
                    <mat-label>Image</mat-label>
                    <div class="relative mt-2">
                        <img
                            alt="Product Image"
                            [src]="selectedProduct.im_media"
                            class="object-cover rounded-lg aspect-square w-full">
                        <button
                            class="absolute bottom-2 right-2"
                            mat-mini-fab
                            color="accent"
                            *ngIf="!reviewMode"
                            (click)="onFileInputClick(selectedProduct.id_destinationproduct)">
                            <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
                        </button>
                    </div>
                    <input
                        hidden
                        type="file"
                        [id]="'FileUpload' + selectedProduct.id_destinationproduct"
                        name="fileUpload"
                        accept="image/*"
                        (change)="onChangeFile($event, selectedProduct)">
                </div>
            </div>
        </div>
    </div>

    <!-- Right Column: Product List -->
    <div class="w-full md:w-80 lg:w-96 flex-shrink-0 flex flex-col border rounded-lg">
        <!-- Add New Product Section -->
        <div class="p-4 border-b flex-shrink-0" *ngIf="!reviewMode">
            <button
                class="w-full"
                (click)="addProduct()"
                mat-flat-button
                color="primary">
                <mat-icon svgIcon="feather:plus-circle"></mat-icon>
                <span class="ml-2">Add {{ productGroup.ds_title_producttype }}</span>
            </button>
        </div>

        <!-- Products List (Scrollable) -->
        <div class="flex-auto overflow-y-auto">
            <div
                *ngFor="let product of productGroup.ar_items"
                class="group flex items-center justify-between p-4 cursor-pointer border-b last:border-b-0 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors duration-200"
                [ngClass]="{'bg-primary-50 dark:bg-primary-900/50': product === selectedProduct}"
                (click)="selectProduct(product)">
                <div class="flex-auto">
                    <div class="font-medium text-base truncate">{{ product.ds_name || 'Untitled Item' }}</div>
                    <div class="text-sm text-secondary">Order: {{ product.vi_order || 'N/A' }}</div>
                </div>
                <button
                    *ngIf="!reviewMode"
                    mat-icon-button
                    color="warn"
                    class="flex-shrink-0 ml-2 opacity-50 group-hover:opacity-100 transition-opacity"
                    (click)="removeProduct(product, $event)">
                    <mat-icon class="!w-5 !h-5" svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
